import { clsx } from 'clsx'

/**
 * Agent identity uses BOTH colour AND glyph AND shape so even on a glance
 * across 14 lanes the type is unambiguous (foldable phones squish UI).
 *
 * Claude = Anthropic-orange circle, "C" (the Claude app-icon terracotta)
 * Codex  = blue square, "X" (OpenAI/Codex product blue)
 * Gemini = amber diamond, "G"
 * Cursor = violet squircle, "R"
 * Grok   = black circle, "K"
 * Mixed  = split provider badge, "M"
 */
export default function AgentBadge({
  agent,
  size = 24,
  number,
}: {
  agent: 'claude' | 'codex' | 'codex-secondary' | 'gemini' | 'cursor' | 'grok' | 'mixed'
  size?: number
  number?: number | null
}) {
  const visualAgent = agent === 'codex-secondary' ? 'codex' : agent
  const isClaude = visualAgent === 'claude'
  const isCodex = visualAgent === 'codex'
  const isGemini = visualAgent === 'gemini'
  const isCursor = visualAgent === 'cursor'
  const isGrok = visualAgent === 'grok'
  const isMixed = visualAgent === 'mixed'
  const label = isClaude
    ? 'Claude'
    : isGemini
      ? 'Gemini'
      : isCursor
        ? 'Cursor'
        : isGrok
          ? 'Grok Build'
        : isMixed
          ? 'Mixed agents'
          : 'Codex'
  const glyph = isClaude ? 'C' : isCodex ? 'X' : isGemini ? 'G' : isCursor ? 'R' : isGrok ? 'K' : 'M'
  return (
    <span
      className={clsx(
        'inline-grid place-items-center text-[10px] font-bold text-white shrink-0',
        isClaude && 'rounded-full bg-[#D97757]',
        isCodex && 'rounded-md bg-blue-600',
        isGemini && 'rotate-45 rounded-sm bg-amber-600',
        isCursor && 'rounded-lg bg-violet-600',
        isGrok && 'rounded-full bg-zinc-950 ring-1 ring-zinc-500',
        isMixed && 'rounded-full',
      )}
      style={{
        width: size,
        height: size,
        ...(isMixed
          ? {
              background:
                'conic-gradient(from 45deg, #D97757 0 33%, #2563eb 33% 66%, #d97706 66% 100%)',
            }
          : {}),
      }}
      aria-label={number != null ? `${label} lane ${number}` : label}
      title={number != null ? `${label} lane ${number}` : label}
    >
      <span className={isGemini ? '-rotate-45' : undefined}>
        {number != null ? `${glyph}${number}` : glyph}
      </span>
    </span>
  )
}
